export const DEFAULT_JOBS_QUERY_PARAMS = {
  limit: 25,
  offset: 0,
  ordering: ['-updated'],
}

export const DEFAULT_CANDIDATES_OVERVIEW_QUERY_PARAMS = {
  limit: 25,
  offset: 0,
  ordering: ['created'],
}

export const DEFAULT_SEND_INVITES_QUERY_PARAMS = {
  limit: 25,
  offset: 0,
  ordering: ['status'],
}

export const DEFAULT_TEST_SCORES_QUERY_PARAMS = {
  limit: 25,
  offset: 0,
  ordering: ['-test_score'],
}

export const DEFAULT_INTERVIEWS_QUERY_PARAMS = {
  limit: 25,
  offset: 0,
  ordering: ['-test_score'],
}

export const DEFAULT_FINAL_RESULTS_QUERY_PARAMS = {
  limit: 25,
  offset: 0,
  ordering: ['-final_score'],
}
